<template>
  <div class="case-trial">
    <Row class="detail-header">
      <span>归档</span>
    </Row>
    <Row class="case-content">
      <Row v-if="!infoCtrl&&isDetailLoad" class="case-form">
        <Form ref="formData" :model="formData" :rules="ruleValidate" :disabled="caseState=='TN'" :label-width="120">
          <FormItem label="结案时间" prop="closeTime">
            <DatePicker
              transfer
              type="date"
              placeholder="请选择结案时间"
              style="width:100%"
              format="yyyy-MM-dd"
              :value="formData.closeTime"
              @on-change="getTime"
            />
          </FormItem>
          <FormItem label="结案方式" prop="closeType">
            <Select v-model="formData.closeType" transfer placeholder="请选择结案方式">
              <Option v-for="item in closeTypeArr" :key="item.id" :value="item.value">{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="应收款" prop="amountReceivable">
            <Row>{{ formData.amountReceivable=='￥0'?'￥0':common.formateNumber(formData.amountReceivable) }}</Row>
          </FormItem> -->
          <!-- <FormItem label="实收款" prop="amountReceived">
            <my-input
              append-text="￥"
              :default-data="formData.amountReceived"
              :to-fixed="2"
              @getValue="getInputValue($event,'amountReceived')"
            />
          </FormItem> -->
          <FormItem label="结案内容" prop="content">
            <Input
              v-model.trim="formData.content"
              type="textarea"
              :autosize="{minRows: 3,maxRows: 8}"
              placeholder="请填写结案内容"
            />
          </FormItem>
          <FormItem label="结案金额" prop="amount">
            <Input
              v-model.trim="formData.amount"
              placeholder="请填写结案金额"
            />
          </FormItem>
          <FormItem label="诉讼分析" prop="litigationAnalysis">
            <Input
              v-model.trim="formData.litigationAnalysis"
              type="textarea"
              :autosize="{minRows: 3,maxRows: 8}"
              placeholder="请填写诉讼分析"
            />
          </FormItem>
          <FormItem label="结案文书" prop="attachmentList">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{}"
              @getFileList="getAttachmentList"
            />
          </FormItem>
          <Row class="detail-btn-box">
            <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="checkAmount">保存</Button>
            <Button @click="infoCtrl=true">取消</Button>
          </Row>
        </Form>
      </Row>
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
        <Row><Col span="5" class="left-label">结案时间：</Col><Col span="16" class="right-content">{{ defaultData.closeTimeStr || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">结案方式：</Col><Col span="16" class="right-content">{{ defaultData.closeTypeName || "" }}</Col></Row>
        <!-- <Row><Col span="5" class="left-label">应收款：</Col><Col span="16" class="right-content">{{ defaultData.amountReceivable || "" }}</Col></Row> -->
        <!-- <Row><Col span="5" class="left-label">实收款：</Col><Col span="16" class="right-content">{{ defaultData.amountReceived || "" }}</Col></Row> -->
        <Row><Col span="5" class="left-label">结案金额：</Col><Col span="16" class="right-content">{{ this.common.formateNumber(defaultData.amount) }}</Col></Row>
        <Row><Col span="5" class="left-label">结案内容：</Col><Col span="16" class="right-content">{{ defaultData.content }}</Col></Row>
        <Row><Col span="5" class="left-label">诉讼分析：</Col><Col span="16" class="right-content">{{ defaultData.litigationAnalysis }}</Col></Row>
        <Row>
          <Col span="5" class="left-label">确认状态：</Col>
          <Col span="16" class="right-content">
            <Tag v-if="defaultData.auditState!='E'" style="border-radius:11px;" :color="styles.warningColor">待确认</Tag>
            <Tag v-else style="border-radius:11px;" :color="styles.successColor">已确认</Tag>
          </Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">结案文书：</Col>
          <Col span="16" class="right-content">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row class="detail-btn-box">
          <Button v-if="defaultData.auditState!='E' && editState" @click="infoCtrl=false">修改</Button>
        </Row>
      </Row>
    </Row>

    <!-- 提示 -->
    <Modal
      v-model="auditCtrl"
      title="结案确认"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">当前实收款低于应收款金额的80%，是否确定结案</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button type="primary" :disabled="isSubmit" @click="submitNew">确认</Button>
        <Button style="margin-left: 8px" @click="auditCtrl=false;">取消</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  components: {},
  props: ['caseId', 'processId', 'editState', 'caseState'],
  data () {
    const validatorFn = (rule, value, callback) => {
      if (isNaN(Number(value))) return callback(new Error('请输入正确的数字'))
      callback()
    }
    return {
      styles: styles,
      auditCtrl: false,
      infoCtrl: true,
      isDetailLoad: false,
      isSubmit: false,
      closeTypeArr: [],
      defaultList: [],
      formData: {
        closeTime: '',
        closeType: '',
        amount: '', // 结案金额
        // amountReceivable: 10000,
        // amountReceived: '',
        content: '',
        litigationAnalysis: '',
        attachmentList: []
      },
      ruleValidate: {
        closeTime: [{ required: true, message: '结案时间不能为空', trigger: 'blur' }],
        closeType: [{ required: true, message: '结案方式不能为空', trigger: 'blur' }],
        amount: [
          { required: true, message: '结案金额不能为空', trigger: 'blur' },
          { validator: validatorFn, trigger: 'blur' }
        ],
        // amountReceived: [{ required: true, message: '实收款不能为空', trigger: 'blur' }],
        content: [{ max: 2048, message: '不能超过2048个字符', trigger: 'blur' }],
        litigationAnalysis: [{ max: 2048, message: '不能超过2048个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getDictionary()
    this.getDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    // 获取应付金额和实收金额
    getAmount() {
      const url = `/business/case/case-close/${this.caseId}/amount`
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.formData.amountReceivable = res.data.receivable || this.common.formateNumber(0)
          this.formData.amountReceived = res.data.received || 0
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    // 获取庭审详情
    getDetail() {
      const url = '/business/case/case-close/' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
        } else {
          this.defaultData = ''
          // this.getAmount()
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    getTime(value) {
      this.formData.closeTime = value
    },
    getAttachmentList(arr) {
      this.formData.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachmentList.push(obj)
      })
    },
    getInputValue(value, key) {
      this.formData[key] = value
    },
    checkAmount() {
      // const amountReceivable = Number(this.formData.amountReceivable) // 应收款
      // const amountReceived = Number(this.formData.amountReceived) // 实收款
      // if (amountReceived / amountReceivable < 0.8) {
      //   this.auditCtrl = true
      // } else {
      //   this.submitNew()
      // }
      this.submitNew()
    },
    submitNew() {
      const url = '/business/case/case-close'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      if (this.formData.amountReceivable == '￥0') {
        ajaxData.amountReceivable = 0
      }
      if (this.defaultData) {
        ajaxData.id = this.defaultData.id
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              this.auditCtrl = false
              if (res.code == 0) {
                this.getDetail()
                this.$emit('reloadProcess')
                this.$Message.success('操作成功')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              this.auditCtrl = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    },
    giveDefaultData() {
      this.formData.closeTime = this.defaultData.closeTimeStr || ''
      this.formData.closeType = this.defaultData.closeType || ''
      // this.formData.amountReceivable = this.defaultData.amountReceivable || ''
      // this.formData.amountReceived = this.defaultData.amountReceived || ''
      this.formData.amount = this.defaultData.amount
      this.formData.content = this.defaultData.content || ''
      this.formData.litigationAnalysis = this.defaultData.litigationAnalysis || ''
      this.defaultList = this.defaultData.attachmentList && this.defaultData.attachmentList.map(item=>{
        return {
          fileName: item.fileName,
          mediaType: item.mediaType,
          url: item.url
        }
      }) || []
      this.formData.attachmentList = this.defaultList || []

      this.isDetailLoad = true
    },
    // 数据字典
    async getDictionary() {
      this.closeTypeArr = await this.common.getDictionaryItems('case_close_type')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
</style>



// WEBPACK FOOTER //
// src/view/civilCase/closeCase/index.vue